import type { ChatMessage, IntentInfo } from '../lib/agent';
import type { TurnTimings } from '../lib/ws';

/** Shown on /two only when VITE_DEBUG=true. */
export function DebugPanel({
  intents,
  status,
  messages,
  timings,
}: {
  intents: readonly IntentInfo[];
  status: string;
  messages: readonly ChatMessage[];
  /** Server timings of the last turn (from the `done` frame). */
  timings?: TurnTimings | null;
}) {
  const textFor = (eventId: string) => messages.find((m) => m.id === eventId)?.text ?? eventId;
  const timingText = timings
    ? Object.entries(timings)
        .map(([k, v]) => `${k} ${v}ms`)
        .join(' · ')
    : 'no turn yet';
  return (
    <details className="shrink-0 border-t border-dashed border-line-strong bg-surface-2 px-3 py-1 text-[11px] text-ink-2">
      <summary className="cursor-pointer select-none">
        debug · socket {status} · {intents.length} intents · {timingText}
      </summary>
      <ul className="max-h-40 overflow-y-auto py-1" dir="ltr">
        {intents.length === 0 ? <li className="text-ink-3">no classifications yet</li> : null}
        {intents.map((i) => (
          <li key={i.event_id} className="flex gap-2 py-0.5">
            <span className="w-20 shrink-0 font-semibold">{i.intent}</span>
            <span className="w-10 shrink-0 tabular-nums">{i.confidence.toFixed(2)}</span>
            <span className="truncate" title={i.trace_id}>
              {textFor(i.event_id)}
            </span>
          </li>
        ))}
      </ul>
    </details>
  );
}
